import type { ViewableKind } from '@/utils/mediaView'

/** SA-981: every sentence the attachment viewer and the download button show. */
export const MEDIA_TEXT = {
  opening: 'Opening…',
  gone: 'File no longer available',
  failed: "Couldn't open the file.",
  tryAgain: 'Try again',
  cannotPlay: "This file can't be played in this browser.",
  cannotShowImage: "This image can't be shown in this browser.",
  openInNewTab: 'Open in new tab',
  download: 'Download',
  preparingDownload: 'Preparing download…',
  downloadAttachment: 'Download attachment',
  downloadFailed: 'Download failed. Try again.',
  /** SA-1110: a small image's and a grid cell's lines, one wording for both. */
  imageGone: 'Image no longer available',
  voiceNoteGone: 'Voice note no longer available',
  unavailable: 'Attachment unavailable',
  loading: 'Loading attachment…',
  attachmentAlt: 'Attachment',
  /** SA-1094: the inline player's caption when the sender gave no file name. */
  videoPlaceholder: 'Video',
  /** SA-1094: the viewer's step buttons over a message's attachments. */
  previous: 'Previous attachment',
  next: 'Next attachment',
} as const

const KIND_LABEL: Record<ViewableKind, string> = {
  pdf: 'View PDF',
  image: 'View image',
  video: 'Play video',
  audio: 'Play audio',
}

/** The view button's words, and the viewer's title, when the sender gave no file name. */
export function kindLabel(kind: ViewableKind): string {
  return KIND_LABEL[kind]
}

/** A small image's thumbnail button: `View <file name>`, else `View image`. */
export function thumbnailLabel(filename: string | null | undefined): string {
  return filename ? `View ${filename}` : 'View image'
}

/** SA-1094: the viewer's place in a message's attachments, "2 of 4". */
export function ofCount(n: number, total: number): string {
  return `${n} of ${total}`
}
